import script from "./ChannelFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelFormModal.vue?vue&type=style&index=0&id=34b1b908&scoped=true&lang=scss"
import "./ChannelFormModal.vue?vue&type=style&index=1&id=34b1b908&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b1b908"]])

export default __exports__